import React, { Component } from 'react'
import { Auth } from '../../../../helpers'
import './YesNoButtons.css'

class YesNoButtons extends Component {
  render () {
    const { myVote, handleVoting } = this.props

    return (
      <div className='vote-bttns-container yes-no-bttns'>
        <div
          onClick={() => handleVoting('yes')}
          className={`vote-bttn ${(myVote && myVote.vote === 'yes' && 'voted')} ${!Auth.isAdmin() && 'cursor-pointer'}`}>
          yes
        </div>
        <div
          onClick={() => handleVoting('no')}
          className={`vote-bttn ${(myVote && myVote.vote === 'no' && 'voted')} ${!Auth.isAdmin() && 'cursor-pointer'}`}>
          no
        </div>
      </div>
    )
  }
}

export default YesNoButtons



// WEBPACK FOOTER //
// ./src/screens/dashboard/chat/buttons/YesNoButtons.js